/**
 * Helpers for free-text decimal fields (course rating, handicap, ...).
 *
 * iOS shows the decimal separator of the device locale on the decimal pad, so a
 * Swedish phone produces "72,3" while an English one produces "72.3".
 * `Number.parseFloat('72,3')` silently returns 72, so every decimal input must
 * be normalized before parsing.
 */
export const normalizeDecimalInput = (value: string): string => value.trim().replace(',', '.');

/** Parses a decimal typed by the user, accepting both "," and "." as separator. */
export const parseDecimalInput = (value: string): number =>
  Number.parseFloat(normalizeDecimalInput(value));
